import { defineComponent, ref } from 'vue';
import { InformationImage } from '@hems/component';
export default defineComponent({
    name: 'EnergyTableRow',
    components: {
        InformationImage,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    emits: ['enter'],
    setup(props, { emit }) {
        const tdLeft = ref(null);
        const tdRight = ref(null);
        function enter(index) {
            if (props.data[index] == null)
                return;
            if (index == 0) {
                emit('enter', getAnimationParams(tdLeft));
                return;
            }
            emit('enter', getAnimationParams(tdRight));
        }
        function getAnimationParams(object) {
            return {
                top: (object.value?.offsetTop || 0) + 50,
                left: object.value?.offsetLeft,
                width: object.value?.offsetWidth,
                height: object.value?.offsetHeight,
                opacity: '1',
                transition: 'all .1s, opacity .1s',
            };
        }
        return { enter, tdLeft, tdRight };
    },
});
